import { Component, OnInit, Input } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
// import { formCompetence } from '../../models/form-comtence';
import { FormCompetenceService } from '../../services/form-competence.service';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import {Observable} from "rxjs";

@Component({
  selector: 'app-form-competence-selector-dialog',
  templateUrl: './form-competence-selector-dialog.component.html',
  styleUrls: ['./form-competence-selector-dialog.component.css']
})
export class FormCompetenceSelectorDialogComponent implements OnInit {
  publicating: boolean = false;
  @Input() UserID;
  @Input() JobID;
  @Input() JobName;
  @Input() nameComponent;
  userId: string;
  errorMessage: string;
  offer_id:string;
  formCompetences:any;
  offername: any;
  jobId: string;
  premium: number;
  loading: boolean;
  listCompetence: Array<any> = [];

  constructor(
    public dialogRef: MdDialogRef<FormCompetenceSelectorDialogComponent>,
    private dialog: MdDialog,
    private router: Router,
    private formCompetenceService: FormCompetenceService) {
  }

  ngOnInit() {
    this.loading = true;
    this.userId = this.UserID;
    this.jobId = this.JobID;
    this.getCompetence();
  }

  getCompetence() {
    this.formCompetenceService.getCompetences()
    .subscribe(
      data => {
        this.formCompetences = data;
        this.listCompetence = [];
        this.formCompetences.forEach(element => {
          this.listCompetence.push ({id:element.id ,value: false});
        });
        this.loading = false;
      }
    );
  }

  changeCompetence(id) {
    const find = this.findElement(id, this.listCompetence);
    this.listCompetence[find].value = !this.listCompetence[find].value;
  }

  public findElement (element, list) {
    let find = -1;
    let itera = 0;
    list.forEach(elementCompetence => {
        if (elementCompetence.id === element) {
            find = itera;
        }
        itera++;
    });
    return find;
  }

  onInviteFormCompetence (f) {
    this.onPostInviteFormCompetence(f);
  }

  onPostInviteFormCompetence(f) {
    let listC = [];
    this.listCompetence.forEach(element => {
      if (element.value) {
        listC.push (element.id);
      }
    });
    this.formCompetenceService.postInvite(listC, this.jobId, this.userId)
    .subscribe(
      data => {
        this.dialogRef.close(data);
        this.dialog.open(MessageBoxDialog, {data: {title: 'Información Dreamjobs', success: true, showIcon: true}});
      },
      error => {
        this.dialog.open(MessageBoxDialog, {data: {title: 'Información Dreamjobs', message:error, success: false, alert: true, showIcon: true}});
      }
    );
  }

  goToOffer(id) {
    // this.dialog.closeAll();
    // this.router.navigate(['viewinvite/' + id]);
  }

  openDialogPaymentCredits() {
    // let dialogRef = this.dialog.open(PaymentDialogComponent);
    // // dialogRef.afterClosed().subscribe(result => {
    // //   this.searchTransactions();
    // // });
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/form-competence-selector-dialog/form-competence-selector-dialog.component.ts